var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15625 7C2.15625 4.48093 2.15625 3.2214 2.93882 2.43882C3.7214 1.65625 4.98093 1.65625 7.5 1.65625C10.019 1.65625 11.2786 1.65625 12.0612 2.43882C12.8438 3.2214 12.8438 4.48093 12.8438 7C12.8438 9.51904 12.8438 10.7786 12.0612 11.5612C11.2786 12.3438 10.019 12.3438 7.5 12.3438C4.98093 12.3438 3.7214 12.3438 2.93882 11.5612C2.15625 10.7786 2.15625 9.51904 2.15625 7Z",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2711 4.76489H8.61464C8.0275 4.76489 7.55027 5.23857 7.54594 5.82572L7.49796 12.3026M6.42111 8.12602H9.12263",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/face-book.d0d60e975bdfce5ad6fbda18a961a5e4.svg";
export { ForwardRef as ReactComponent };